import cloneDeep from 'clone-deep'
import { LayoutLoading } from 'components/LayoutLoading'
import { useEffect, useState } from 'react'
import { getAdminConfig, setAdminConfig } from 'services'
import { removeComma } from 'utils'
import { RenderInput } from 'utils/RenderInput'

import { defaultInputs } from './constants'

export const FeeConfiguration = () => {
  const [inputs, setInputs] = useState(defaultInputs())
  const [isLoading, setLoading] = useState(false)

  useEffect(() => {
    setLoading(true)
    getAdminConfig('fee')
      .then((value) => {
        let newInputs = cloneDeep(inputs)
        Object.keys(inputs).forEach((key1) => {
          const items = inputs[key1]
          Object.keys(items).map((key2) => {
            newInputs[key1][key2].value = value?.[key1]?.[key2] ?? ''
          })
        })
        setInputs(newInputs)
      })
      .finally(() => setLoading(false))
  }, [])

  const onChange = (key1: string, key2: string, value: any) => {
    const nInputs = cloneDeep(inputs)
    nInputs[key1][key2].value = value
    setInputs(nInputs)
  }

  const onSubmit = async () => {
    const data: Record<string, any> = {}
    Object.keys(inputs).forEach((key1) => {
      const items = inputs[key1]
      data[key1] = {}
      Object.keys(items).map((key2) => {
        if (inputs[key1][key2].inputType === 'section') return
        data[key1][key2] = removeComma(inputs[key1][key2].value)
      })
    })
    setLoading(true)
    await setAdminConfig('fee', data)
    setLoading(false)
  }

  return (
    <div className="relative">
      <LayoutLoading show={isLoading} />

      <div className="grid grid-cols-1 md:grid-cols-2 sm:gird-cols-2 gap-2">
        {Object.keys(inputs).map((key1) => {
          const items = inputs[key1]
          return Object.keys(items).map((key2, index) => {
            const item = items[key2]
            return (
              <div className={`input md:col-span-${item.span || 1} `} key={index}>
                <RenderInput
                  key={index}
                  input={item}
                  Key={key2}
                  onChange={(_: any, value: any) => onChange(key1, key2, value)}
                  onBlur={onSubmit}
                />
              </div>
            )
          })
        })}
      </div>
    </div>
  )
}
